import { BASE } from './index';
import axios from './http';
const category = {
    // 分类列表
    categorieslist: params => axios.post(`${BASE.PRO1}/categories/new/list`, params ),
    // 排序接口
    categoriessort: params => axios.post(`${BASE.PRO1}/categories/sort`, params ),
    // 二级分类列表
    newcategories: params => axios.post(`${BASE.PRO1}/get/new/categories`, params ),
    // 二级分类列表
    newcategoriessort: params => axios.post(`${BASE.PRO1}/categories/sort`, params ),
    // 二级分类列表
    newcategoriesisshow: params => axios.post(`${BASE.PRO1}/categories/is/show`, params ),
 
};

export default category;
